module.exports = __webpack_public_path__ + "img/multiselectCaret.f2dadf57.svg";